<div class="eventdetails">
    <form [formGroup]="eventDetailForm" (ngSubmit)="onEventFormSubmit()" id="createEvent-form" novalidate>
        <div class="eventdetails__container-img">
            <img class="eventdetails__img" [src]="pictureUrl" alt="event1">
            <div class="eventdetails__img-text-top-left">
                <div *ngIf="operation != operationEdit" class="eventdetails__img-text-top-left">
                    <div class="eventdetails__img-text-top-left eventstatus">
                        <div *ngIf="eventDetails.status == 'Active'">{{ 'EVENTS.ELIVE' | translate }}</div>
                        <div *ngIf="eventDetails.status == 'Published'">{{ 'EVENTS.EPUBLISHED' | translate }}</div>
                        <div *ngIf="eventDetails.status == 'Created'">{{ 'EVENTS.EDRAFT' | translate }}</div>
                        <div *ngIf="eventDetails.status == 'Finished'">{{ 'EVENTS.EPAST' | translate }}</div>
                    </div>
                </div>
                <div *ngIf="operation == operationEdit" class="eventdetails__img-text-top-left-edit">
                    <div (click)="cropAndCompressImageDialog()" class="d-flex flex-row">
                        <mat-icon class="edit-icon">brush</mat-icon>
                    </div>
                </div>
            </div>
            <div class="eventdetails__img-text-top-right">
                <a routerLink="/promoter/events" [queryParams]="navigateToTab ? { activeIndex: navigateToTab } : {}">
                    <mat-icon>clear</mat-icon>
                </a>
            </div>
            <div *ngIf="eventDetails.status=='Created' || eventDetails.status=='Published'"
                class="eventdetails__img-text-bottom-right">
                <mat-spinner *ngIf="loadingPage" class="sign-in-spinner"></mat-spinner>
                <button *ngIf="operation != operationEdit" type="submit" class="button" (click)="editEvent()">{{
                    'EVENTS.EDIT_EVENT' | translate }}</button>
                <button *ngIf="operation != operationEdit && eventDetails.status=='Created'" type="button"
                    class="button" (click)="PublishEvent()">{{ 'EVENTS.PUBLISH_EVENT' | translate }}</button>
                <button *ngIf="operation != operationEdit" type="button" class="button" (click)="CancelEvent()">{{
                    'EVENTS.CANCEL_EVENT' | translate }}</button>
                <button *ngIf="operation == operationEdit" type="submit" class="button"
                    [disabled]="eventDetailForm.invalid">{{
                    'SAVE_CHANGES' |
                    translate }}</button>
                <button *ngIf="operation == operationEdit" type="button" class="button" (click)="CancelEdit()">{{
                    'CANCEL_CHANGES' | translate }}</button>
            </div>
        </div>
        <mat-accordion>
            <mat-expansion-panel hideToggle (opened)="eventPanelOpenState=true" (closed)="eventPanelOpenState=false"
                expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="border"><span class="material-icons drop-icon">expand_more</span></div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="create-event ps-4 pt-4 pe-4">
                    <div class="d-flex flex-row gap-5">
                        <div class="w-100">
                            <div class="d-flex flex-row justify-content-between label-info">
                                <label for="eventname1">{{ 'EVENTS.EVENT_NAME' | translate }}</label>
                                <div *ngIf="eventFormControls.eventName?.invalid && (eventFormControls.eventName?.dirty || eventFormControls.eventName?.touched)"
                                    class="alert alert-danger">
                                    <div class="d-flex flex-row alert-danger-content">
                                        <div class="alert-danger-info"
                                            *ngIf="eventFormControls.eventName?.errors?.['required']"
                                            matTooltipClass="tooltip-danger"
                                            matTooltip="{{ 'INFO.ENAME_REQUIRED' | translate }}">
                                            <div>?</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <textarea #MyEventName type="text" id="eventname1" class="custom-scroll-bar"
                                [value]="eventDetails.name" formControlName="eventName"
                                placeholder="{{ 'INFO.PLACEHOLDER' | translate }}"
                                (input)="eventname = MyEventName.value" [maxlength]="maxChars"></textarea>
                            <p *ngIf="operation == operationEdit" class="text-end">
                                {{eventname.length}}/{{maxChars}}<span class="char-count">C</span></p>
                        </div>
                        <div class="w-100">
                            <div class="d-flex flex-row justify-content-between label-info">
                                <label for="description1">{{ 'EVENTS.EVENT_DESCRIPTION' | translate }}</label>
                                <div *ngIf="eventFormControls.eventDescription?.invalid && (eventFormControls.eventDescription?.dirty || eventFormControls.eventDescription?.touched)"
                                    class="alert alert-danger">
                                    <div class="d-flex flex-row alert-danger-content">
                                        <div class="alert-danger-info"
                                            *ngIf="eventFormControls.eventDescription?.errors?.['required']"
                                            matTooltipClass="tooltip-danger"
                                            matTooltip="{{ 'INFO.EDESCRIPTION_REQUIRED' | translate }}">
                                            <div>?</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <textarea #MyEventDescription type="text" id="description1" class="custom-scroll-bar"
                                [value]="eventDetails.description" formControlName="eventDescription"
                                placeholder="{{ 'INFO.PLACEHOLDER' | translate }}"
                                (input)="description1 = MyEventDescription.value"
                                [maxlength]="description1maxChars"></textarea>
                            <p *ngIf="operation == operationEdit" class="text-end">
                                {{description1.length}}/{{description1maxChars}}<span class="char-count">C</span>
                            </p>
                        </div>

                        <div class="d-flex flex-column w-100" style="width:1000px !important;">
                            <div class="d-flex flex-row gap-3 mb-3" style="width:240px;">
                                <div class="w-100">
                                    <div class="d-flex flex-row justify-content-between label-info">
                                        <label for="date">{{ 'EVENTS.DATE' | translate }}</label>
                                        <div *ngIf="eventFormControls.eventDate.invalid && (eventFormControls.eventDate?.dirty || eventFormControls.eventDate?.touched)"
                                            class="alert alert-danger">
                                            <div class="d-flex flex-row alert-danger-content">
                                                <div class="alert-danger-info"
                                                    *ngIf="eventFormControls.eventDate?.errors?.['required']"
                                                    matTooltipClass="tooltip-danger"
                                                    matTooltip="{{ 'INFO.DATE_REQUIRED' | translate }}">
                                                    <div>?</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <p-calendar dateTimeMask formControlName="eventDate" [minDate]="minDate"
                                        [showIcon]="true" placeholder="mm/dd/yyyy"></p-calendar>
                                </div>
                                <div class="w-100">
                                    <div class="d-flex flex-row justify-content-between label-info">
                                        <label for="time">{{ 'EVENTS.TIME' | translate }}</label>
                                        <div *ngIf="eventFormControls.starTTime.invalid && (eventFormControls.starTTime.dirty || eventFormControls.starTTime?.touched)"
                                            class="alert alert-danger">
                                            <div class="d-flex flex-row alert-danger-content">
                                                <div class="alert-danger-info"
                                                    *ngIf="eventFormControls.starTTime?.errors?.['required']"
                                                    matTooltipClass="tooltip-danger"
                                                    matTooltip="{{ 'INFO.TIME_REQUIRED' | translate }}">
                                                    <div>?</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="errorModel!=null && errorModel['pastdatetime']!=null" class="alert alert-danger">
                                            <div class="d-flex flex-row alert-danger-content">
                                                <div class="alert-danger-info"
                                                    matTooltipClass="tooltip-danger"
                                                    matTooltip="{{errorModel['pastdatetime']|translate}}">
                                                    <div>?</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="eventFormControls.endTime.invalid && (eventFormControls.endTime.dirty || eventFormControls.endTime?.touched)"
                                            class="alert alert-danger">
                                            <div class="d-flex flex-row alert-danger-content">
                                                <div class="alert-danger-info"
                                                    *ngIf="eventFormControls.endTime?.errors?.['required']"
                                                    matTooltipClass="tooltip-danger"
                                                    matTooltip="{{ 'INFO.TIME_REQUIRED' | translate }}">
                                                    <div>?</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <p-calendar dateTimeMask formControlName="starTTime" [timeOnly]="true"
                                        [showTime]="true" hourFormat="24" icon="pi pi-clock" [showIcon]="true"
                                        placeholder="hh:mm"></p-calendar>
                                    <p-calendar dateTimeMask formControlName="endTime" [timeOnly]="true"
                                        [showTime]="true" hourFormat="24" icon="pi pi-clock" [showIcon]="true"
                                        placeholder="hh:mm"></p-calendar>
                                </div>
                            </div>

                            <div class="w-100">
                                <div class="d-flex flex-row types__buisness justify-content-between label-info">
                                    <label>{{'EVENTS.EVENT_TYPE' | translate}}</label>
                                    <div *ngIf="eventFormControls.eventTypes.invalid && (eventFormControls.eventTypes.dirty || eventFormControls.eventTypes.touched)"
                                        class="alert alert-danger">
                                        <div class="d-flex flex-row alert-danger-content">
                                            <div class="alert-danger-info" matTooltipClass="tooltip-danger"
                                                matTooltip="{{ 'INFO.CHOOSE_MORE_PATTERN' | translate }}">
                                                <div>?</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p-multiSelect [filter]="false" [showToggleAll]="true"
                                    filterPlaceHolder="{{'SEARCH' | translate}}..." [options]="eventTypeList"
                                    formControlName="eventTypes" defaultLabel="{{ 'INFO.CHOOSE_MORE' | translate }}"
                                    optionLabel="name" optionValue="id" [maxSelectedLabels]="2"
                                    selectedItemsLabel="{0} {{ 'INFO.ITEMS_SELECTED' | translate }}">
                                    <ng-template pTemplate="header">
                                        <div class="checkbox-all-text">{{ "SELECT_ALL" | translate }}</div>
                                    </ng-template>
                                </p-multiSelect>
                            </div>
                        </div>

                        <div class="w-100 d-flex flex-column">
                            <div class="mb-3">
                                <div class="d-flex flex-row types__buisness justify-content-between label-info">
                                    <label>{{ 'VENUES.VENUE' | translate }}</label>
                                    <div *ngIf="eventFormControls.venue.invalid && (eventFormControls.venue.dirty || eventFormControls.venue.touched)"
                                        class="alert alert-danger">
                                        <div class="d-flex flex-row alert-danger-content">
                                            <div class="alert-danger-info" matTooltipClass="tooltip-danger"
                                                matTooltip="{{ 'INFO.CHOOSE_MORE_PATTERN' | translate }}">
                                                <div>?</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p-dropdown [options]="this.venuesList" formControlName="venue"
                                    (onChange)="selectedVenue(eventFormControls.venue.value)" optionLabel="name"
                                    optionValue="id" [showClear]="false"
                                    placeholder="{{ 'INFO.SELECT_VENUE' | translate }}">
                                </p-dropdown>
                            </div>
                            <!-- <div *ngIf="operation == operationEdit">
                                <label class="label-info" for="capacity">{{ 'EVENTS.CAPACITY' | translate }}</label>
                                <div
                                    class="create-event__capacity d-flex flex-row justify-content-between align-items-center">
                                    <div class="d-flex flex-row align-items-center">
                                        <mat-icon>person</mat-icon>
                                        <p class="ps-1">{{capacity}}</p>
                                    </div>
                                    <div class="d-flex flex-row align-items-center" (click)="openCapacity()"
                                        style="text-align: right; cursor: pointer;">
                                        <mat-icon>event_note</mat-icon>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div *ngIf="operation == operationRead"> -->
                                <div>
                                <label class="label-info" for="capacity">{{ 'EVENTS.CAPACITY' | translate }}</label>
                                <div
                                    class="create-event__capacity d-flex flex-row justify-content-between align-items-center">
                                    <div class="d-flex flex-row align-items-center">
                                        <mat-icon>person</mat-icon>
                                        <p class="ps-1">{{capacity}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </form>
</div>
<section *ngIf="this.eventDetails.status != 'Created'">
    <app-reservation-panel [eventIdForReservation]="eventIdForReservation"></app-reservation-panel>
</section>